module.exports = __webpack_public_path__ + "img/vendor.1116f80d.jpeg";